import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { FeaturedListings } from './components/FeaturedListings';
import { Testimonials } from './components/Testimonials';
import { MarketStats } from './components/MarketStats';
import { CTABanner } from './components/CTABanner';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-body text-charcoal selection:bg-gold selection:text-charcoal" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <About data-id="element-4" />
        <Services data-id="element-5" />
        <FeaturedListings data-id="element-6" />
        <Testimonials data-id="element-7" />
        <MarketStats data-id="element-8" />
        <CTABanner data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}